import React from 'react'

import { Props } from './types'
import { SeparatorComponent } from './styles'

const Separator = ({
  variant,
  height,
  margin,
  ...props
}: Props & React.HTMLAttributes<HTMLDivElement>) => (
  <SeparatorComponent
    variant={variant}
    height={height}
    margin={margin}
    role="separator"
    {...props}
  />
)

export default Separator
